import { ReviewList } from '@/components/feature/shop/review-list';
import { ReviewKioskBanner } from '@/components/feature/shop/review-kiosk-banner';
import { ShopMenu } from '@/components/feature/shop/shop-menu';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from './styles.module.scss';
import type { MenuItem, ReviewItem } from '@/types/shop';
import { useConfigStore } from '@/stores';
import { filterInvalidMenuList } from '@/utils/fnb';

type Props = {
    menuList?: MenuItem[] | null | undefined;
    reviewList?: ReviewItem[];
    showReview?: boolean;
    firstRef?: (node?: Element | null) => void;
    lastRef?: (node?: Element | null) => void;
};

const ReviewMenuSlideHorizontal = ({ menuList, reviewList, showReview, firstRef, lastRef }: Props) => {
    const { t } = useTranslation();
    const currentLanguage = useConfigStore((state) => state.config.ui.language);
    const validMenuList = filterInvalidMenuList(menuList || []);
    return (
        <div>
            <div ref={firstRef} className="relative h-fit">
                {validMenuList && validMenuList.length > 0 && <ShopMenu tabIndex={1} showReview={showReview} menuList={validMenuList} />}
                {showReview && (
                    <div
                        className={clsx(styles['review-menu-slides__message'], {
                            ['widescreen:mt-[calc(12*var(--vh-unit))]']: menuList && menuList.length > 0,
                        })}
                    >
                        <span>{'\u203B'}</span>
                        <span>{t('shop.message.recent_merchant_reviews')}</span>
                    </div>
                )}
            </div>

            {!showReview && currentLanguage === 'ko' && (
                <div ref={lastRef} className={clsx({ ['widescreen:mt-[calc(24*var(--vh-unit))]']: menuList && menuList.length > 0 })}>
                    <ReviewKioskBanner tabIndex={2} />
                </div>
            )}

            {showReview && (
                <div className="widescreen:mt-[calc(10*var(--vh-unit))] w-full">
                    <ReviewList tabIndex={2} reviewList={reviewList} lastItemRef={lastRef} />
                </div>
            )}
        </div>
    );
};

export default ReviewMenuSlideHorizontal;
